const n = (e) => typeof e < "u";
export {
  n as isDefined
};
